import * as React from 'react';
import BaseButton, { BaseButtonState } from '../common/BaseButton';

interface ExtraToolIconButton {
  readonly onClick?: () => void;
  readonly src: string;
  readonly href?: string;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly disabled?: boolean;
}

const buttonStyle: React.CSSProperties = {
  width: '48px',
  height: '48px',
  margin: '8px',
};

const imageBaseStyle: React.CSSProperties = {
  backgroundSize: 'contain',
};

const render = (state: BaseButtonState, props: ExtraToolIconButton): JSX.Element => {
  const { src: imagePath, disabled } = props;

  const buttonAdditionalStyle: React.CSSProperties = {};

  // 固有ツールのアイコン画像は1種類のみ指定するのでstyleで各ハイライトを付ける
  // TODO: 決定仕様を反映
  if (disabled) {
    buttonAdditionalStyle.filter = 'brightness(0.5)';
  }
  if (!disabled && state.hovered && !state.pressed) {
    buttonAdditionalStyle.filter = 'brightness(1.5)';
  }
  if (state.pressed) {
    buttonAdditionalStyle.filter = 'brightness(0.75)';
  }

  return(
    <div style={{
      ...buttonStyle,
      ...buttonAdditionalStyle,
      ...imageBaseStyle,
      backgroundImage: `url("${imagePath}")`,
    }} />
  );
};

const ExtraToolIconButton: React.SFC<ExtraToolIconButton> = React.memo((props) => {
  const { onClick, href, title, ariaLabel, disabled } = props;

  return (
    <BaseButton
      render={state => render(state, props)}
      onClick={onClick}
      href={href}
      title={title}
      ariaLabel={ariaLabel}
      active={true}
      disabled={disabled} />
  );
});

export default ExtraToolIconButton;
